export default __webpack_public_path__ + "static/media/learose4-2048w.c7d81c2a.webp";